import { defineStore } from "pinia";

export const useSidebarStore = defineStore("sidebar", {
  state: () => ({
    drawer: true,
  }),
  actions: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    setDrawer(value) {
      this.drawer = value;
    },
  },
});
